module.exports = __webpack_public_path__ + "static/media/bg.1f198240.jpg";